import { connect } from "react-redux";
import PmSoftwarePendingSities from "./ApprovedList";
import { bindActionCreators } from "redux";
import {
    pmSoftwareMaintenanceSites,
    fetchMonth,
    PMSoftwareDownloadList,
    getPmSoftwareFilterDropDown
} from "services/redux/maintenance/pmSities/action";

const mapStateToProps = (state) => ({
    pmSoftwareSitesDetails: state.pmSitiesReducer.pmSoftwareSitesDetails,
    maintenanceMonth: state.pmSitiesReducer.maintenanceMonth,
    pmSoftwareFilterResponse: state.pmSitiesReducer.pmSoftwareFilterResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pmSoftwareMaintenanceSites,
            fetchMonth,
            PMSoftwareDownloadList,
            getPmSoftwareFilterDropDown
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PmSoftwarePendingSities);
